import { render, staticRenderFns } from "./SelectRoleNew.vue?vue&type=template&id=577351d1&scoped=true"
import script from "./SelectRoleNew.vue?vue&type=script&lang=js"
export * from "./SelectRoleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577351d1",
  null
  
)

export default component.exports